import { render, staticRenderFns } from "./ThemeSheet.vue?vue&type=template&id=20a838ac&scoped=true"
import script from "./ThemeSheet.vue?vue&type=script&lang=js"
export * from "./ThemeSheet.vue?vue&type=script&lang=js"
import style0 from "./ThemeSheet.vue?vue&type=style&index=0&id=20a838ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a838ac",
  null
  
)

export default component.exports